
import React from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import Toolbar from "../../../components/toolbar/Toolbar";
import { Column } from 'primereact/column';
import { routes } from '../../../constants';
import { Page } from "../../../components/page/Page";
import { ModalList } from "./ModalList";
import { actions } from '../modal.actions'


const mapStateToProps = state => {
  return {
    columns: state.crudModalState.columns,
    records: state.crudModalState.records,
    first: state.crudModalState.index,
    rows: state.crudModalState.max,
    totalRecords: state.crudModalState.count,
    sortField: state.crudModalState.sortField,
    order: state.crudModalState.sortOrder
  }
}
const mapDispatchToProps = dispatch => {
  return {
    paginate: paginationParams => dispatch(actions.paginate(paginationParams)),
    sortOrder: sortParams => dispatch(actions.sortOrder(sortParams)),
    applyFilter: filterParams => {
      dispatch(actions.setType(null));
      dispatch(actions.applyFilter(filterParams))
    },
    load: () => dispatch(actions.load())
  }
}


class ModalListPageContainer extends React.Component {

  newHandler = () => {
    this.props.history.push(`${routes.PATH_MODAL}/novo`)
  }
  componentDidMount() {
    this.props.load();
  }


  onPage = (e) => {
    this.props.paginate({
      max: e.rows,
      index: e.first
    })
  }
  onSort = (e) => {
    console.log('sorting', e);
    this.props.sortOrder({
      sortOrder: e.sortOrder,
      sortField: e.sortField
    })


  }
  onFilter = (e) => {
    console.log(e);
    const filters = [];
    const keys = Object.keys(e.filters) || [];
    keys.forEach(key => {
      filters.push({
        campo: key,
        valor: e.filters[key].value,
        tipoFiltro: 'CONTEM'

      })
    })
    console.log(filters);
    this.props.applyFilter(filters)
  }

  render() {
    const header = (
      <div>
        <h1>Modals</h1>
        <div>
          <Toolbar onNew={this.newHandler} newButtonStyle='highlighted'>
          </Toolbar >
        </div>
      </div>
    );
    const oidTemplate = (rowData, column) => {
      return (
        <div className="id-link"> <Link to={`${routes.PATH_MODAL}/${rowData.oid}`} title={rowData.oid}>{rowData.oid}</Link> </div>
      )
    }

    const transportTypeTemplate = (rowData, column) => {
      const data = {
        AIR: "Aéreo", ROAD: "Rodoviário", SEA: "Marítimo"
      }
      const value = data[rowData.transportType] || '';
      return (
        <div style={{ textAlign: 'center' }}>{value}</div>
      )
    }
    const freightTableTypeTemplate = (rowData, column) => {
      const data = {
        R: "Rodoviária"
      }
      const value = data[rowData.freightTableType] || '';
      return (
        <div style={{ textAlign: 'center' }}>{value}</div>
      )
    }
    const pickupTypeTemplate = (rowData, column) => {
      const data = {
        N: "Normal", U: "Urgente", WD: "Sem entrega"
      }
      const value = data[rowData.pickupType] || '';
      return (
        <div style={{ textAlign: 'center' }}>{value}</div>
      )
    }
    const deliveryTypeTemplate = (rowData, column) => {
      const data = {
        N: "Normal", U: "Urgente", WD: "Sem entrega"
      }
      const value = data[rowData.deliveryType] || '';
      return (
        <div style={{ textAlign: 'center' }}>{value}</div>
      )
    }
    const columns = this.props.columns.map(col => {
      if (col.field === 'oid') {
        return (<Column {...col} key={col.field} body={oidTemplate} />);
      }


      if (col.field === 'transportType') {
        return (<Column {...col} key={col.field} body={transportTypeTemplate} />);
      }
      if (col.field === 'freightTableType') {
        return (<Column {...col} key={col.field} body={freightTableTypeTemplate} />);
      }
      if (col.field === 'pickupType') {
        return (<Column {...col} key={col.field} body={pickupTypeTemplate} />);
      }
      if (col.field === 'deliveryType') {
        return (<Column {...col} key={col.field} body={deliveryTypeTemplate} />);
      }
      return (<Column {...col} key={col.field} />)
    })

    const content = <ModalList  {...this.props} onFilter={this.onFilter} onPage={this.onPage} onSort={this.onSort} columns={columns} />;
    return <Page header={header} content={content} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalListPageContainer);
